import { AlertOptions } from "../interface";
import { store } from "../store/ui";

function alertBox(message: string, options?: AlertOptions): Promise<void> {
    return new Promise((callback) => {
        store.setAlertData({
            message,
            options: options || {},
            callback
        });
    });
}

export { alertBox };
